import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import UserCrudService from '../../services/UserCrudService';
import RoleCrudService from '../../services/RoleCrudService';
import ProviderTypeService from '../../services/ProviderTypeService';
import Spinner from '../utils/Spinner';

export default function ModalUser({ show, handleClose, dataItem, setRenderRows }) {

  const [getAllRoles, setGetAllRoles] = useState([]);
  const conditionView = (dataItem.typeView === 'View' || dataItem.typeView === 'Delete') ? true : false;
  const providerTypeOptions = ProviderTypeService.getAllProviders();

  const [userName, setUserName] = useState(null);
  const [userUserName, setUserUserName] = useState(null);
  const [userEmail, setUserEmail] = useState(null);
  const [userRole, setUserRole] = useState('');
  const [userCategory, setUserCategory] = useState('T1PAGINAS');
  const [userPassword, setUserPassword] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    
    RoleCrudService.getAllRoles().then(async res => {
      setGetAllRoles(res.data.data);
    });

    if (show && dataItem.codeItem > 0) {
      UserCrudService.getUserById(dataItem.codeItem).then(async res => {

        let currentUser = res.data.data[0];

        setUserName(currentUser.name);
        setUserUserName(currentUser.username);
        setUserEmail(currentUser.email);
        setUserRole(currentUser.role);
        setUserCategory(currentUser.category);

      });
    } else {
      setUserName(null);
      setUserUserName(null);
      setUserEmail(null);
      setUserRole('');
      setUserCategory('T1PAGINAS');
      setUserPassword(null);
      setGetAllRoles([]);
    }
  }, [dataItem, show]);

  function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time)
    )
  }

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    setIsLoading(true);

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();

    } else {

      let updateUser = { name: userName, username: userUserName, email: userEmail, role: userRole, category:userCategory};
      //console.log('userUpdate => ' + JSON.stringify(updateUser));
      //console.log('idUser => ' + JSON.stringify(dataItem.codeItem));

      if(userPassword){
        updateUser['password'] = userPassword;
      }
      if (!dataItem.codeItem && dataItem.typeView === 'Create') {

        //updateUser['password'] = userPassword;

        if (updateUser.name === '' || updateUser.username === '' || updateUser.password === '') {
          setIsLoading(false);
        } else {
          UserCrudService.createUser(updateUser).then(res => {
        sleep(1500).then(() => {
          setIsLoading(false);
          handleClose();
          setRenderRows();
        });
          });
        }

      } else {
        UserCrudService.updateUser(updateUser, dataItem.codeItem).then(res => {
          sleep(1500).then(() => {
            setIsLoading(false);
            handleClose();
            setRenderRows();
          });
        });

      }
    }

  };

  const changeUserNameHandler = (event) => {
    setUserName(event.target.value);
  }

  const changeUserUserNameHandler = (event) => {
    setUserUserName(event.target.value);
  }

  const changeUserEmailHandler = (event) => {
    setUserEmail(event.target.value);
  }

  const changeUserRoleHandler = (event) => {
    setUserRole(event.target.value);
  }

  const changeUserCategoryHandler = (event) => {
    setUserCategory(event.target.value);
  }

  const changeUserPasswordHandler = (event) => {
    setUserPassword(event.target.value);
  }

  let fieldPassword = "";
  //if (dataItem.typeView === 'Create') {
    fieldPassword = (<>
      <Form.Group as={Col} md="10" controlId="validCustom6">
        <Form.Label>Password</Form.Label>
        <Form.Control
          placeholder="Your Password"
          type="password"
          aria-describedby="passwordHelpBlock"
          defaultValue=""
          onChange={conditionView ? null : changeUserPasswordHandler}
          readOnly={conditionView ? true : false}
        />
        <Form.Text id="passwordHelpBlock" muted>
          8-20 characters long with letters and numbers and without spaces, special characters or emojis.
        </Form.Text>
      </Form.Group>
    </>)
  //}

  let addSubmitButton = "";
  if (!conditionView) {
    addSubmitButton = <Button type="button" onClick={handleSubmit}>Save</Button>;
  }

  return (
    <>
      <Modal show={show} onHide={handleClose}  backdrop="static">
        <Modal.Header>
          <Modal.Title> {dataItem.typeView} {dataItem.nameView} Code {dataItem.codeItem}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="mb-3">

              <Form.Group as={Col} md="7" controlId="validCustom1">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Name"
                  defaultValue={userName}
                  onChange={conditionView ? null : changeUserNameHandler}
                  readOnly={conditionView ? true : false}
                />
              </Form.Group>

              <Form.Group as={Col} md="5" controlId="validCustom2">
                <Form.Label>UserName</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="UserName"
                  defaultValue={userUserName}
                  onChange={conditionView ? null : changeUserUserNameHandler}
                  readOnly={conditionView ? true : false}
                />
              </Form.Group>

              <Form.Group as={Col} md="12" controlId="validCustom4">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="@Email"
                  defaultValue={userEmail}
                  onChange={conditionView ? null : changeUserEmailHandler}
                  readOnly={conditionView ? true : false}
                />
              </Form.Group>
            </Row>

            <Row className="mb-3">

              <Form.Group as={Col} md="6" controlId="validCustom5">
                <Form.Label>Role</Form.Label>
                <Form.Select
                  required="Role is required"
                  aria-label="Default select"
                  onChange={conditionView ? null : changeUserRoleHandler}
                  readOnly={conditionView ? true : false}
                  value={userRole}
                >
                  <option>Select Role</option>
                  {getAllRoles.map((itemRole) => {                    
                    return (<option key={itemRole.code} value={itemRole._id} >{itemRole.name}</option>)
                  })}
                </Form.Select>
              </Form.Group>

              <Form.Group as={Col} md="6" controlId="validCustom7">
                <Form.Label>Category</Form.Label>
                <Form.Select
                  required="Category is required"
                  aria-label="Default select"
                  onChange={conditionView ? null : changeUserCategoryHandler}
                  readOnly={conditionView ? true : false}
                  value={userCategory}
                >

                    {providerTypeOptions.map((itemRole) => {
                        return (<option key={itemRole} value={itemRole}>{itemRole}</option>)
                      })}

                </Form.Select>
              </Form.Group>

              {fieldPassword}
              </Row>
                {isLoading ? <Spinner /> : null}
                <hr></hr>
            {addSubmitButton} {'  '}  {'  '}
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}